import { Link } from "react-router-dom";
import StatusBadge from "@/components/base/StatusBadge";

export interface CaseCardItem {
  id: string;
  slug: string;
  title: string;
  category: string;
  status: string;
  summary: string;
  cover: string;
  publishDate: string;
  updatedDate: string;
  readTime: string;
  heat: number;
  tags: string[];
}

export default function CaseCard({ item, rank }: { item: CaseCardItem; rank?: number }) {
  return (
    <article className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300">
      <Link to={`/cases/${item.slug}`} className="block">
        <div className="relative h-44 w-full overflow-hidden bg-background-200">
          <img
            src={item.cover}
            alt={`${item.title}案例封面图`}
            title={`${item.title} - 瓜田黑料案例档案`}
            className="h-44 w-full object-top transition-transform duration-500 group-hover:scale-[1.03]"
          />
          {typeof rank === "number" && (
            <span className="absolute left-3 top-3 flex h-8 w-8 items-center justify-center rounded-md bg-primary-900/90 font-heading text-sm font-bold text-background-50">
              {String(rank).padStart(2, "0")}
            </span>
          )}
        </div>
      </Link>

      <div className="flex flex-1 flex-col p-4 md:p-5">
        <div className="mb-3 flex flex-wrap items-center gap-2">
          <span className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-secondary-100 px-2.5 py-1 text-[11px] font-medium text-secondary-900">
            <i className="ri-price-tag-3-line text-xs" aria-hidden="true" />
            {item.category}
          </span>
          <StatusBadge label={item.status} />
        </div>

        <h3 className="font-heading text-base font-semibold leading-snug text-foreground-950">
          <Link to={`/cases/${item.slug}`} className="transition-colors hover:text-primary-700">
            {item.title}
          </Link>
        </h3>

        <p className="mt-2 line-clamp-3 text-sm leading-relaxed text-foreground-600">{item.summary}</p>

        <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-2 border-t border-background-200 pt-3 text-[11px] text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line text-sm" aria-hidden="true" />
            更新于 {item.updatedDate}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line text-sm" aria-hidden="true" />
            {item.readTime}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-fire-line text-sm text-accent-500" aria-hidden="true" />
            热度 {item.heat}
          </span>
        </div>
      </div>
    </article>
  );
}